import { render, staticRenderFns } from "./sport-home-custom-banner.vue?vue&type=template&id=47d96ea2"
import script from "./sport-home-custom-banner.vue?vue&type=script&lang=js"
export * from "./sport-home-custom-banner.vue?vue&type=script&lang=js"
import style0 from "./sport-home-custom-banner.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-home-custom-banner.vue
// module id = OyPt
// module chunks = 0